import paymentMethodsConf from '@/configuration/sources/smartform/paymentMethodsConf.yml'

export function initSmartformMethods() {
  const obj = {}
  ;['ALL', ...paymentMethodsConf.whitelist].forEach(method => {
    obj[method] = {
      icon: null,
      label: null,
      displayPaymentReceipt: null // null represents default behavior, true, false
    }
  })
  return obj
}
export function skipPaymentTicketUtil({ activeMethod, paymentMethods }) {
  const methodConfig = paymentMethods[activeMethod]?.displayPaymentReceipt
  if (activeMethod && methodConfig !== null) return !methodConfig
  const ALLConfig = paymentMethods['ALL'].displayPaymentReceipt
  if (ALLConfig !== null) return !ALLConfig
  return false
}
